import { qzTrayConfigurationApi } from "../../api";

/**
 * ⚙️ QzTrayConfigurationService
 *
 * Gestiona las operaciones relacionadas con la configuración
 * del cliente QZ Tray por tenant/sucursal:
 *
 * - Obtener configuración activa por tenant
 * - Guardar o actualizar configuración
 * - Probar conexión
 * - Listar todas las configuraciones registradas
 */
const QzTrayConfigurationService = {
  /**
   * 🔍 Obtener configuración activa
   * GET /api/qztray/config/active/{tenantId}
   */
  getActiveConfiguration: async (tenantId: string) => {
    const response = await qzTrayConfigurationApi.fetchCustom(`/active/${tenantId}`);
    return response.data;
  },

  /**
   * 💾 Guardar o actualizar configuración
   * POST /api/qztray/config/save
   */
  saveOrUpdateConfiguration: async (data: {
    host: string;
    port: number;
    protocol: "ws" | "wss";
    sslEnabled: boolean;
    timeoutMs: number;
    tenantId: string;
    branchId: number;
  }) => {
    const response = await qzTrayConfigurationApi.addCustom(`/save`, data);
    return response.data;
  },

  /**
   * 🧪 Probar conexión QZ Tray
   * POST /api/qztray/config/test
   */
  testConnection: async (data: {
    host: string;
    port: number;
    protocol: "ws" | "wss";
    sslEnabled: boolean;
    timeoutMs: number;
    tenantId: string;
    branchId: number;
  }) => {
    const response = await qzTrayConfigurationApi.addCustom(`/test`, data);
    return response.data;
  },

  /**
   * 📋 Listar todas las configuraciones
   * GET /api/qztray/config/all
   */
  getAllConfigurations: async () => {
    const response = await qzTrayConfigurationApi.fetchCustom(`/all`);
    return response.data;
  },
};

export default QzTrayConfigurationService;
